import { execute } from 'fg-frontend/src/partialUpdate/partialUpdate';

export const eshopUserToolsRefresh = () => {
	execute({
		target: [ 'userLists', 'userListsRwd' ],
		url:    `/qf/${ window.projectConfig.lang }/ramjet/include`,
	});
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/webActions/eshopUserToolsRefresh.js